//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class Client {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    catalogIntegration_GetCatalogIntegrationCatalogViewerSettings(catalogKey: string, integrationKey: string): Observable<CatalogIntegrationCatalogViewerDto> {
        let url_ = this.baseUrl + "/api/v3/CatalogIntegration/catalogViewerIntegration/{catalogKey}/{integrationKey}";
        if (catalogKey === undefined || catalogKey === null)
            throw new Error("The parameter 'catalogKey' must be defined.");
        url_ = url_.replace("{catalogKey}", encodeURIComponent("" + catalogKey));
        if (integrationKey === undefined || integrationKey === null)
            throw new Error("The parameter 'integrationKey' must be defined.");
        url_ = url_.replace("{integrationKey}", encodeURIComponent("" + integrationKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogIntegration_GetCatalogIntegrationCatalogViewerSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogIntegration_GetCatalogIntegrationCatalogViewerSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogIntegrationCatalogViewerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogIntegrationCatalogViewerDto>;
        }));
    }

    protected processCatalogIntegration_GetCatalogIntegrationCatalogViewerSettings(response: HttpResponseBase): Observable<CatalogIntegrationCatalogViewerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogIntegrationCatalogViewerDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogIntegration_GetCatalogIntegrationCatalogItemViewerSettings(catalogKey: string, integrationKey: string): Observable<CatalogIntegrationCatalogItemViewerDto> {
        let url_ = this.baseUrl + "/api/v3/CatalogIntegration/catalogItemViewerIntegration/{catalogKey}/{integrationKey}";
        if (catalogKey === undefined || catalogKey === null)
            throw new Error("The parameter 'catalogKey' must be defined.");
        url_ = url_.replace("{catalogKey}", encodeURIComponent("" + catalogKey));
        if (integrationKey === undefined || integrationKey === null)
            throw new Error("The parameter 'integrationKey' must be defined.");
        url_ = url_.replace("{integrationKey}", encodeURIComponent("" + integrationKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogIntegration_GetCatalogIntegrationCatalogItemViewerSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogIntegration_GetCatalogIntegrationCatalogItemViewerSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogIntegrationCatalogItemViewerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogIntegrationCatalogItemViewerDto>;
        }));
    }

    protected processCatalogIntegration_GetCatalogIntegrationCatalogItemViewerSettings(response: HttpResponseBase): Observable<CatalogIntegrationCatalogItemViewerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogIntegrationCatalogItemViewerDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogIntegration_GetSingleCatalogKeyAndCatalogItemIdsByCatalogItemGuids(catalogItemGuids: string[]): Observable<CatalogKeyAndCatalogItemIdsDto> {
        let url_ = this.baseUrl + "/api/v3/CatalogIntegration/singleCatalogKeyAndCatalogItemIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(catalogItemGuids);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogIntegration_GetSingleCatalogKeyAndCatalogItemIdsByCatalogItemGuids(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogIntegration_GetSingleCatalogKeyAndCatalogItemIdsByCatalogItemGuids(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogKeyAndCatalogItemIdsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogKeyAndCatalogItemIdsDto>;
        }));
    }

    protected processCatalogIntegration_GetSingleCatalogKeyAndCatalogItemIdsByCatalogItemGuids(response: HttpResponseBase): Observable<CatalogKeyAndCatalogItemIdsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogKeyAndCatalogItemIdsDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogsAz_GetCatalogsGroupedByTitleFirstLetter(): Observable<{ [key: string]: CatalogForAzDto[]; }> {
        let url_ = this.baseUrl + "/api/v3/CatalogsAz/az";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogsAz_GetCatalogsGroupedByTitleFirstLetter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogsAz_GetCatalogsGroupedByTitleFirstLetter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: CatalogForAzDto[]; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: CatalogForAzDto[]; }>;
        }));
    }

    protected processCatalogsAz_GetCatalogsGroupedByTitleFirstLetter(response: HttpResponseBase): Observable<{ [key: string]: CatalogForAzDto[]; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: CatalogForAzDto[]; };
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogsCategories_GetCategoriesWithCatalogs(): Observable<CatalogsCategoriesGroupDto[]> {
        let url_ = this.baseUrl + "/api/v3/CatalogsCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogsCategories_GetCategoriesWithCatalogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogsCategories_GetCategoriesWithCatalogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogsCategoriesGroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogsCategoriesGroupDto[]>;
        }));
    }

    protected processCatalogsCategories_GetCategoriesWithCatalogs(response: HttpResponseBase): Observable<CatalogsCategoriesGroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogsCategoriesGroupDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetCatalogInformationByCatalogKey(catalogKey: string): Observable<CatalogViewCatalogInformationDto> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/catalogKey/{catalogKey}";
        if (catalogKey === undefined || catalogKey === null)
            throw new Error("The parameter 'catalogKey' must be defined.");
        url_ = url_.replace("{catalogKey}", encodeURIComponent("" + catalogKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetCatalogInformationByCatalogKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetCatalogInformationByCatalogKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogViewCatalogInformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogViewCatalogInformationDto>;
        }));
    }

    protected processCatalogView_GetCatalogInformationByCatalogKey(response: HttpResponseBase): Observable<CatalogViewCatalogInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogViewCatalogInformationDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetRelatedCatalogsByCatalogKey(catalogKey: string): Observable<CatalogViewRelatedCatalogsDto[]> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/catalogKey/{catalogKey}/related";
        if (catalogKey === undefined || catalogKey === null)
            throw new Error("The parameter 'catalogKey' must be defined.");
        url_ = url_.replace("{catalogKey}", encodeURIComponent("" + catalogKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetRelatedCatalogsByCatalogKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetRelatedCatalogsByCatalogKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogViewRelatedCatalogsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogViewRelatedCatalogsDto[]>;
        }));
    }

    protected processCatalogView_GetRelatedCatalogsByCatalogKey(response: HttpResponseBase): Observable<CatalogViewRelatedCatalogsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogViewRelatedCatalogsDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetNewsForCatalogView(catalogKey: string): Observable<CatalogViewNewsShortDto[]> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/catalogKey/{catalogKey}/newsCatalogView";
        if (catalogKey === undefined || catalogKey === null)
            throw new Error("The parameter 'catalogKey' must be defined.");
        url_ = url_.replace("{catalogKey}", encodeURIComponent("" + catalogKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetNewsForCatalogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetNewsForCatalogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogViewNewsShortDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogViewNewsShortDto[]>;
        }));
    }

    protected processCatalogView_GetNewsForCatalogView(response: HttpResponseBase): Observable<CatalogViewNewsShortDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogViewNewsShortDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetNewsForDialog(catalogKey: string): Observable<CatalogViewNewsListDto> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/catalogKey/{catalogKey}/newsDialog";
        if (catalogKey === undefined || catalogKey === null)
            throw new Error("The parameter 'catalogKey' must be defined.");
        url_ = url_.replace("{catalogKey}", encodeURIComponent("" + catalogKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetNewsForDialog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetNewsForDialog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogViewNewsListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogViewNewsListDto>;
        }));
    }

    protected processCatalogView_GetNewsForDialog(response: HttpResponseBase): Observable<CatalogViewNewsListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogViewNewsListDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetForeignLanguageCatalogsByCatalogKey(catalogKey: string): Observable<CatalogViewForeignLanguageCatalogsDto[]> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/catalogKey/{catalogKey}/foreignLanguages";
        if (catalogKey === undefined || catalogKey === null)
            throw new Error("The parameter 'catalogKey' must be defined.");
        url_ = url_.replace("{catalogKey}", encodeURIComponent("" + catalogKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetForeignLanguageCatalogsByCatalogKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetForeignLanguageCatalogsByCatalogKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogViewForeignLanguageCatalogsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogViewForeignLanguageCatalogsDto[]>;
        }));
    }

    protected processCatalogView_GetForeignLanguageCatalogsByCatalogKey(response: HttpResponseBase): Observable<CatalogViewForeignLanguageCatalogsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogViewForeignLanguageCatalogsDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetAttachmentTagsByCatalogKey(catalogKey: string): Observable<CatalogViewTagDto[]> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/catalogKey/{catalogKey}/tags";
        if (catalogKey === undefined || catalogKey === null)
            throw new Error("The parameter 'catalogKey' must be defined.");
        url_ = url_.replace("{catalogKey}", encodeURIComponent("" + catalogKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetAttachmentTagsByCatalogKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetAttachmentTagsByCatalogKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogViewTagDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogViewTagDto[]>;
        }));
    }

    protected processCatalogView_GetAttachmentTagsByCatalogKey(response: HttpResponseBase): Observable<CatalogViewTagDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogViewTagDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetCatalogItemDetailsByCatalogItemGuid(catalogItemGuid: string): Observable<CatalogItemDetailsDto> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/catalogItemGuid/{catalogItemGuid}/details";
        if (catalogItemGuid === undefined || catalogItemGuid === null)
            throw new Error("The parameter 'catalogItemGuid' must be defined.");
        url_ = url_.replace("{catalogItemGuid}", encodeURIComponent("" + catalogItemGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetCatalogItemDetailsByCatalogItemGuid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetCatalogItemDetailsByCatalogItemGuid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogItemDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogItemDetailsDto>;
        }));
    }

    protected processCatalogView_GetCatalogItemDetailsByCatalogItemGuid(response: HttpResponseBase): Observable<CatalogItemDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogItemDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetCatalogMetaByCatalogKey(catalogKey: string): Observable<CatalogViewGroupDto> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/catalogKey/{catalogKey}/meta";
        if (catalogKey === undefined || catalogKey === null)
            throw new Error("The parameter 'catalogKey' must be defined.");
        url_ = url_.replace("{catalogKey}", encodeURIComponent("" + catalogKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetCatalogMetaByCatalogKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetCatalogMetaByCatalogKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogViewGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogViewGroupDto>;
        }));
    }

    protected processCatalogView_GetCatalogMetaByCatalogKey(response: HttpResponseBase): Observable<CatalogViewGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogViewGroupDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetCatalogItemMetaDataByGuid(catalogGuid: string): Observable<CatalogItemMetaDto> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/catalogItem/{catalogGuid}/meta";
        if (catalogGuid === undefined || catalogGuid === null)
            throw new Error("The parameter 'catalogGuid' must be defined.");
        url_ = url_.replace("{catalogGuid}", encodeURIComponent("" + catalogGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetCatalogItemMetaDataByGuid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetCatalogItemMetaDataByGuid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogItemMetaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogItemMetaDto>;
        }));
    }

    protected processCatalogView_GetCatalogItemMetaDataByGuid(response: HttpResponseBase): Observable<CatalogItemMetaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogItemMetaDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetIsCatalogItemPartOfCatalog(catalogKey: string, catalogItemGuid: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/isCatalogItemPartOfCatalog/{catalogKey}/{catalogItemGuid}";
        if (catalogKey === undefined || catalogKey === null)
            throw new Error("The parameter 'catalogKey' must be defined.");
        url_ = url_.replace("{catalogKey}", encodeURIComponent("" + catalogKey));
        if (catalogItemGuid === undefined || catalogItemGuid === null)
            throw new Error("The parameter 'catalogItemGuid' must be defined.");
        url_ = url_.replace("{catalogItemGuid}", encodeURIComponent("" + catalogItemGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetIsCatalogItemPartOfCatalog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetIsCatalogItemPartOfCatalog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCatalogView_GetIsCatalogItemPartOfCatalog(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetCatalogViewTreeItemTypes(): Observable<CatalogViewTreeItemType[]> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/itemTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetCatalogViewTreeItemTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetCatalogViewTreeItemTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogViewTreeItemType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogViewTreeItemType[]>;
        }));
    }

    protected processCatalogView_GetCatalogViewTreeItemTypes(response: HttpResponseBase): Observable<CatalogViewTreeItemType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogViewTreeItemType[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetCadenasDataByUrl(cadenasIdentifier?: string | null | undefined): Observable<CadenasDto> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/CadenasData?";
        if (cadenasIdentifier !== undefined && cadenasIdentifier !== null)
            url_ += "cadenasUrl=" + encodeURIComponent("" + cadenasIdentifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetCadenasDataByUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetCadenasDataByUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CadenasDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CadenasDto>;
        }));
    }

    protected processCatalogView_GetCadenasDataByUrl(response: HttpResponseBase): Observable<CadenasDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CadenasDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetDgnbSustainabilityInfo(catalogItemGuid?: string | undefined): Observable<DgnbDto> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/DGNBSustainabilityInfo?";
        if (catalogItemGuid === null)
            throw new Error("The parameter 'catalogItemGuid' cannot be null.");
        else if (catalogItemGuid !== undefined)
            url_ += "catalogItemGuid=" + encodeURIComponent("" + catalogItemGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetDgnbSustainabilityInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetDgnbSustainabilityInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DgnbDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DgnbDto>;
        }));
    }

    protected processCatalogView_GetDgnbSustainabilityInfo(response: HttpResponseBase): Observable<DgnbDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DgnbDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetFolderView(catalogGuids: string[]): Observable<CatalogItemFolderViewDto[]> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/folderViewItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(catalogGuids);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetFolderView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetFolderView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogItemFolderViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogItemFolderViewDto[]>;
        }));
    }

    protected processCatalogView_GetFolderView(response: HttpResponseBase): Observable<CatalogItemFolderViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogItemFolderViewDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetCatalogContactsByCatalogKey(catalogKey: string): Observable<CatalogViewContactListDto> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/catalogContact/catalogKey/{catalogKey}";
        if (catalogKey === undefined || catalogKey === null)
            throw new Error("The parameter 'catalogKey' must be defined.");
        url_ = url_.replace("{catalogKey}", encodeURIComponent("" + catalogKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetCatalogContactsByCatalogKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetCatalogContactsByCatalogKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogViewContactListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogViewContactListDto>;
        }));
    }

    protected processCatalogView_GetCatalogContactsByCatalogKey(response: HttpResponseBase): Observable<CatalogViewContactListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogViewContactListDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetBimObjectViewerSource(gtin: string, language: CatalogLanguage): Observable<BimObjectEmbedData> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/bimObjectViewer/gtin/{gtin}/language/{language}";
        if (gtin === undefined || gtin === null)
            throw new Error("The parameter 'gtin' must be defined.");
        url_ = url_.replace("{gtin}", encodeURIComponent("" + gtin));
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetBimObjectViewerSource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetBimObjectViewerSource(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BimObjectEmbedData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BimObjectEmbedData>;
        }));
    }

    protected processCatalogView_GetBimObjectViewerSource(response: HttpResponseBase): Observable<BimObjectEmbedData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BimObjectEmbedData;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    common_GetCatalogIdByCatalogKeyForPreview(catalogKey: string): Observable<number> {
        let url_ = this.baseUrl + "/api/v3/Common/catalogId/catalogKey/{catalogKey}";
        if (catalogKey === undefined || catalogKey === null)
            throw new Error("The parameter 'catalogKey' must be defined.");
        url_ = url_.replace("{catalogKey}", encodeURIComponent("" + catalogKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommon_GetCatalogIdByCatalogKeyForPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommon_GetCatalogIdByCatalogKeyForPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCommon_GetCatalogIdByCatalogKeyForPreview(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    common_GetUseNewHelpdesk(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v3/Common/useNewHelpdesk";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommon_GetUseNewHelpdesk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommon_GetUseNewHelpdesk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCommon_GetUseNewHelpdesk(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    common_GetHelpdeskContent(solution: string, helpId: string, language: string): Observable<string> {
        let url_ = this.baseUrl + "/api/v3/Common/getHelpdeskContent/solution/{solution}/id/{helpId}/language/{language}";
        if (solution === undefined || solution === null)
            throw new Error("The parameter 'solution' must be defined.");
        url_ = url_.replace("{solution}", encodeURIComponent("" + solution));
        if (helpId === undefined || helpId === null)
            throw new Error("The parameter 'helpId' must be defined.");
        url_ = url_.replace("{helpId}", encodeURIComponent("" + helpId));
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommon_GetHelpdeskContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommon_GetHelpdeskContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCommon_GetHelpdeskContent(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    common_GetHelpdeskRoute(solution: string, helpId: string, language: string): Observable<string> {
        let url_ = this.baseUrl + "/api/v3/Common/getHelpdeskRoute/solution/{solution}/id/{helpId}/language/{language}";
        if (solution === undefined || solution === null)
            throw new Error("The parameter 'solution' must be defined.");
        url_ = url_.replace("{solution}", encodeURIComponent("" + solution));
        if (helpId === undefined || helpId === null)
            throw new Error("The parameter 'helpId' must be defined.");
        url_ = url_.replace("{helpId}", encodeURIComponent("" + helpId));
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommon_GetHelpdeskRoute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommon_GetHelpdeskRoute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCommon_GetHelpdeskRoute(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    contactForm_GetContactForm(catalogKey: string): Observable<ContactFormDto> {
        let url_ = this.baseUrl + "/api/v3/ContactForm/{catalogKey}";
        if (catalogKey === undefined || catalogKey === null)
            throw new Error("The parameter 'catalogKey' must be defined.");
        url_ = url_.replace("{catalogKey}", encodeURIComponent("" + catalogKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactForm_GetContactForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactForm_GetContactForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactFormDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactFormDto>;
        }));
    }

    protected processContactForm_GetContactForm(response: HttpResponseBase): Observable<ContactFormDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContactFormDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    contactForm_SendContactForm(catalogKey: string, valuesDto: ContactFormValuesDto): Observable<ContactFormSendResult> {
        let url_ = this.baseUrl + "/api/v3/ContactForm/{catalogKey}";
        if (catalogKey === undefined || catalogKey === null)
            throw new Error("The parameter 'catalogKey' must be defined.");
        url_ = url_.replace("{catalogKey}", encodeURIComponent("" + catalogKey));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(valuesDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactForm_SendContactForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactForm_SendContactForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactFormSendResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactFormSendResult>;
        }));
    }

    protected processContactForm_SendContactForm(response: HttpResponseBase): Observable<ContactFormSendResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContactFormSendResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    contactForm_RefreshCaptcha(): Observable<CaptchaDto> {
        let url_ = this.baseUrl + "/api/v3/ContactForm/refreshCaptcha";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactForm_RefreshCaptcha(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactForm_RefreshCaptcha(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaptchaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaptchaDto>;
        }));
    }

    protected processContactForm_RefreshCaptcha(response: HttpResponseBase): Observable<CaptchaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaptchaDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    download_GetAttachmentDownloadUri(attachmentId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/v3/Download/attachment/{attachmentId}";
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload_GetAttachmentDownloadUri(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload_GetAttachmentDownloadUri(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDownload_GetAttachmentDownloadUri(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    download_GetAttachmentDownloadStream(fileName: string, attachmentId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v3/Download/fileName/{fileName}/attachment/{attachmentId}";
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload_GetAttachmentDownloadStream(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload_GetAttachmentDownloadStream(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownload_GetAttachmentDownloadStream(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    feedback_SendFeedback(dto: SimpleFeedbackDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v3/Feedback/send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFeedback_SendFeedback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFeedback_SendFeedback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFeedback_SendFeedback(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    home_GetCatalogsForLogoBar(): Observable<HomeLogoBarCatalogDto[]> {
        let url_ = this.baseUrl + "/api/v3/Home/logobar";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHome_GetCatalogsForLogoBar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHome_GetCatalogsForLogoBar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HomeLogoBarCatalogDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HomeLogoBarCatalogDto[]>;
        }));
    }

    protected processHome_GetCatalogsForLogoBar(response: HttpResponseBase): Observable<HomeLogoBarCatalogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HomeLogoBarCatalogDto[];
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    home_GetCatalogsForLogoWalls(logoWallType?: LogoWallType | undefined): Observable<LogoWallDto[]> {
        let url_ = this.baseUrl + "/api/v3/Home/logowall?";
        if (logoWallType === null)
            throw new Error("The parameter 'logoWallType' cannot be null.");
        else if (logoWallType !== undefined)
            url_ += "logoWallType=" + encodeURIComponent("" + logoWallType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHome_GetCatalogsForLogoWalls(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHome_GetCatalogsForLogoWalls(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LogoWallDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LogoWallDto[]>;
        }));
    }

    protected processHome_GetCatalogsForLogoWalls(response: HttpResponseBase): Observable<LogoWallDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LogoWallDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    home_GetStatisticsCounts(): Observable<HomeStatisticsDto> {
        let url_ = this.baseUrl + "/api/v3/Home/statistics";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHome_GetStatisticsCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHome_GetStatisticsCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HomeStatisticsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HomeStatisticsDto>;
        }));
    }

    protected processHome_GetStatisticsCounts(response: HttpResponseBase): Observable<HomeStatisticsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HomeStatisticsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    infocenter_GetNewsForDialog(): Observable<InhouseNewsDto[]> {
        let url_ = this.baseUrl + "/api/v3/Infocenter/newsDialog";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInfocenter_GetNewsForDialog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInfocenter_GetNewsForDialog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InhouseNewsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InhouseNewsDto[]>;
        }));
    }

    protected processInfocenter_GetNewsForDialog(response: HttpResponseBase): Observable<InhouseNewsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InhouseNewsDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    infocenter_GetAdminNewsForDialog(): Observable<InhouseNewsDto[]> {
        let url_ = this.baseUrl + "/api/v3/Infocenter/adminNewsDialog";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInfocenter_GetAdminNewsForDialog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInfocenter_GetAdminNewsForDialog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InhouseNewsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InhouseNewsDto[]>;
        }));
    }

    protected processInfocenter_GetAdminNewsForDialog(response: HttpResponseBase): Observable<InhouseNewsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InhouseNewsDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    infocenter_GetNewsIds(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/v3/Infocenter/newsIds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInfocenter_GetNewsIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInfocenter_GetNewsIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processInfocenter_GetNewsIds(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    infocenter_GetAdminNewsIds(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/v3/Infocenter/adminNewsIds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInfocenter_GetAdminNewsIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInfocenter_GetAdminNewsIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processInfocenter_GetAdminNewsIds(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    internationalCatalogs_GetCatalogsGroupedByLanguage(): Observable<CatalogsLanguagesGroupDto[]> {
        let url_ = this.baseUrl + "/api/v3/InternationalCatalogs/international-catalogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInternationalCatalogs_GetCatalogsGroupedByLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInternationalCatalogs_GetCatalogsGroupedByLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogsLanguagesGroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogsLanguagesGroupDto[]>;
        }));
    }

    protected processInternationalCatalogs_GetCatalogsGroupedByLanguage(response: HttpResponseBase): Observable<CatalogsLanguagesGroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogsLanguagesGroupDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchFeedbackForm_GetSearchFeedbackFormData(): Observable<SearchFeedbackFormDto> {
        let url_ = this.baseUrl + "/api/v3/SearchFeedbackForm";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchFeedbackForm_GetSearchFeedbackFormData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchFeedbackForm_GetSearchFeedbackFormData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchFeedbackFormDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchFeedbackFormDto>;
        }));
    }

    protected processSearchFeedbackForm_GetSearchFeedbackFormData(response: HttpResponseBase): Observable<SearchFeedbackFormDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchFeedbackFormDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchFeedbackForm_SendSearchFeedbackForm(valuesDto: SearchFeedbackFormValuesDto): Observable<SearchFeedbackFormSendResult> {
        let url_ = this.baseUrl + "/api/v3/SearchFeedbackForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(valuesDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchFeedbackForm_SendSearchFeedbackForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchFeedbackForm_SendSearchFeedbackForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchFeedbackFormSendResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchFeedbackFormSendResult>;
        }));
    }

    protected processSearchFeedbackForm_SendSearchFeedbackForm(response: HttpResponseBase): Observable<SearchFeedbackFormSendResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchFeedbackFormSendResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchFeedbackForm_RefreshCaptcha(): Observable<CaptchaDto> {
        let url_ = this.baseUrl + "/api/v3/SearchFeedbackForm/refreshCaptcha";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchFeedbackForm_RefreshCaptcha(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchFeedbackForm_RefreshCaptcha(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaptchaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaptchaDto>;
        }));
    }

    protected processSearchFeedbackForm_RefreshCaptcha(response: HttpResponseBase): Observable<CaptchaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaptchaDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    watchList_GetWatchListInformation(): Observable<WatchListInformationDto> {
        let url_ = this.baseUrl + "/api/v3/WatchList/information";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWatchList_GetWatchListInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWatchList_GetWatchListInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WatchListInformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WatchListInformationDto>;
        }));
    }

    protected processWatchList_GetWatchListInformation(response: HttpResponseBase): Observable<WatchListInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WatchListInformationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    watchList_AddCatalogItemToWatchList(catalogItemGuid?: string | undefined): Observable<WatchListFlatDto> {
        let url_ = this.baseUrl + "/api/v3/WatchList/add/catalogItem?";
        if (catalogItemGuid === null)
            throw new Error("The parameter 'catalogItemGuid' cannot be null.");
        else if (catalogItemGuid !== undefined)
            url_ += "catalogItemGuid=" + encodeURIComponent("" + catalogItemGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWatchList_AddCatalogItemToWatchList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWatchList_AddCatalogItemToWatchList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WatchListFlatDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WatchListFlatDto>;
        }));
    }

    protected processWatchList_AddCatalogItemToWatchList(response: HttpResponseBase): Observable<WatchListFlatDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WatchListFlatDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    watchList_AddPositionsToWatchList(catalogItemGuids: string[]): Observable<WatchListFlatDto> {
        let url_ = this.baseUrl + "/api/v3/WatchList/add/positions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(catalogItemGuids);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWatchList_AddPositionsToWatchList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWatchList_AddPositionsToWatchList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WatchListFlatDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WatchListFlatDto>;
        }));
    }

    protected processWatchList_AddPositionsToWatchList(response: HttpResponseBase): Observable<WatchListFlatDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WatchListFlatDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    watchList_RemoveCatalogItemFromWatchList(catalogItemGuid?: string | undefined): Observable<WatchListFlatDto> {
        let url_ = this.baseUrl + "/api/v3/WatchList/remove/catalogItem?";
        if (catalogItemGuid === null)
            throw new Error("The parameter 'catalogItemGuid' cannot be null.");
        else if (catalogItemGuid !== undefined)
            url_ += "catalogItemGuid=" + encodeURIComponent("" + catalogItemGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWatchList_RemoveCatalogItemFromWatchList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWatchList_RemoveCatalogItemFromWatchList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WatchListFlatDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WatchListFlatDto>;
        }));
    }

    protected processWatchList_RemoveCatalogItemFromWatchList(response: HttpResponseBase): Observable<WatchListFlatDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WatchListFlatDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    watchList_RemoveCatalogItemsFromWatchListByCatalogId(catalogId?: number | undefined): Observable<WatchListFlatDto> {
        let url_ = this.baseUrl + "/api/v3/WatchList/remove/catalog?";
        if (catalogId === null)
            throw new Error("The parameter 'catalogId' cannot be null.");
        else if (catalogId !== undefined)
            url_ += "catalogId=" + encodeURIComponent("" + catalogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWatchList_RemoveCatalogItemsFromWatchListByCatalogId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWatchList_RemoveCatalogItemsFromWatchListByCatalogId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WatchListFlatDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WatchListFlatDto>;
        }));
    }

    protected processWatchList_RemoveCatalogItemsFromWatchListByCatalogId(response: HttpResponseBase): Observable<WatchListFlatDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WatchListFlatDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    watchList_CheckForRemoveIfCatalogItemIsInUserDefinedList(catalogItemGuid?: string | undefined): Observable<WatchListCheckDto> {
        let url_ = this.baseUrl + "/api/v3/WatchList/check/remove/catalogItem?";
        if (catalogItemGuid === null)
            throw new Error("The parameter 'catalogItemGuid' cannot be null.");
        else if (catalogItemGuid !== undefined)
            url_ += "catalogItemGuid=" + encodeURIComponent("" + catalogItemGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWatchList_CheckForRemoveIfCatalogItemIsInUserDefinedList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWatchList_CheckForRemoveIfCatalogItemIsInUserDefinedList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WatchListCheckDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WatchListCheckDto>;
        }));
    }

    protected processWatchList_CheckForRemoveIfCatalogItemIsInUserDefinedList(response: HttpResponseBase): Observable<WatchListCheckDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WatchListCheckDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    watchList_CheckForRemoveIfCatalogItemsAreInUserDefinedListByCatalogId(catalogId?: number | undefined): Observable<WatchListCheckDto> {
        let url_ = this.baseUrl + "/api/v3/WatchList/check/remove/catalog?";
        if (catalogId === null)
            throw new Error("The parameter 'catalogId' cannot be null.");
        else if (catalogId !== undefined)
            url_ += "catalogId=" + encodeURIComponent("" + catalogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWatchList_CheckForRemoveIfCatalogItemsAreInUserDefinedListByCatalogId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWatchList_CheckForRemoveIfCatalogItemsAreInUserDefinedListByCatalogId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WatchListCheckDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WatchListCheckDto>;
        }));
    }

    protected processWatchList_CheckForRemoveIfCatalogItemsAreInUserDefinedListByCatalogId(response: HttpResponseBase): Observable<WatchListCheckDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WatchListCheckDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    watchList_RemoveAllCatalogItemsFromWatchList(): Observable<WatchListFlatDto> {
        let url_ = this.baseUrl + "/api/v3/WatchList/remove/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWatchList_RemoveAllCatalogItemsFromWatchList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWatchList_RemoveAllCatalogItemsFromWatchList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WatchListFlatDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WatchListFlatDto>;
        }));
    }

    protected processWatchList_RemoveAllCatalogItemsFromWatchList(response: HttpResponseBase): Observable<WatchListFlatDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WatchListFlatDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    watchList_RemoveAllUnavailableCatalogItemsFromWatchList(): Observable<WatchListFlatDto> {
        let url_ = this.baseUrl + "/api/v3/WatchList/remove/all/unavailable";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWatchList_RemoveAllUnavailableCatalogItemsFromWatchList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWatchList_RemoveAllUnavailableCatalogItemsFromWatchList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WatchListFlatDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WatchListFlatDto>;
        }));
    }

    protected processWatchList_RemoveAllUnavailableCatalogItemsFromWatchList(response: HttpResponseBase): Observable<WatchListFlatDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WatchListFlatDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    watchList_GetWatchListStructure(structureInfo?: WatchListStructure | undefined): Observable<WatchListDto> {
        let url_ = this.baseUrl + "/api/v3/WatchList/structure?";
        if (structureInfo === null)
            throw new Error("The parameter 'structureInfo' cannot be null.");
        else if (structureInfo !== undefined)
            url_ += "structureInfo=" + encodeURIComponent("" + structureInfo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWatchList_GetWatchListStructure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWatchList_GetWatchListStructure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WatchListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WatchListDto>;
        }));
    }

    protected processWatchList_GetWatchListStructure(response: HttpResponseBase): Observable<WatchListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WatchListDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    watchList_GetWatchListStructureFromEveryone(catalogItemGuids: string[], structureInfo?: WatchListStructure | undefined): Observable<WatchListDto> {
        let url_ = this.baseUrl + "/api/v3/WatchList/structure/everyone?";
        if (structureInfo === null)
            throw new Error("The parameter 'structureInfo' cannot be null.");
        else if (structureInfo !== undefined)
            url_ += "structureInfo=" + encodeURIComponent("" + structureInfo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(catalogItemGuids);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWatchList_GetWatchListStructureFromEveryone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWatchList_GetWatchListStructureFromEveryone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WatchListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WatchListDto>;
        }));
    }

    protected processWatchList_GetWatchListStructureFromEveryone(response: HttpResponseBase): Observable<WatchListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WatchListDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    watchList_GetWatchListAsFlatList(): Observable<WatchListFlatDto> {
        let url_ = this.baseUrl + "/api/v3/WatchList/flatlist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWatchList_GetWatchListAsFlatList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWatchList_GetWatchListAsFlatList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WatchListFlatDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WatchListFlatDto>;
        }));
    }

    protected processWatchList_GetWatchListAsFlatList(response: HttpResponseBase): Observable<WatchListFlatDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WatchListFlatDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface CatalogIntegrationCatalogViewerDto {
    catalogIntegrationType: CatalogIntegrationType;
    canNavigateToStartingPage: boolean;
    showForeignLanguageCatalogs: boolean;
    showRelatedCatalogs: boolean;
    canHighlightCatalogItem: boolean;
    canSearch: boolean;
    neutralDesign: boolean;
    collapseNavigation: boolean;
}

export enum CatalogIntegrationType {
    None = 0,
    CatalogViewer = 1,
    CatalogItemViewer = 2,
    ExportDialogDeprecated = 3,
    DirectExport = 4,
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export interface CatalogIntegrationCatalogItemViewerDto {
    neutralDesign: boolean;
}

export interface CatalogKeyAndCatalogItemIdsDto {
    catalogKey?: string | undefined;
    catalogItemIds?: number[] | undefined;
}

export interface CatalogViewListItemBase {
    id: number;
    key?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    isNew: boolean;
    isSustainable: boolean;
    hasNews: boolean;
}

export interface CatalogForAzDto extends CatalogViewListItemBase {
    hasInternationalCatalog: boolean;
    categoryKeys?: string[] | undefined;
}

export interface CatalogsCategoriesGroupDto {
    id: number;
    titleResourceKey?: string | undefined;
    logo?: string | undefined;
    categories?: CatalogsCategoriesCategoryDto[] | undefined;
}

export interface CatalogsCategoriesCategoryDto {
    id: number;
    titleResourceKey?: string | undefined;
    catalogs?: CatalogsCategoriesCatalogDto[] | undefined;
}

export interface CatalogsCategoriesCatalogDto extends CatalogViewListItemBase {
    hasInternationalCatalog: boolean;
    isNewDate?: Date | undefined;
}

export interface CatalogViewCatalogInformationDto {
    id: number;
    key?: string | undefined;
    catalogState: CatalogStateEnum;
    title?: string | undefined;
    description?: string | undefined;
    catalogMetaDescription?: string | undefined;
    language: CatalogLanguage;
    categoryResourceKeys?: { [key: string]: string[]; } | undefined;
    categoryGroupIds?: number[] | undefined;
    featureToggles?: FeatureToggleValuesDto | undefined;
    watchListVersion?: string | undefined;
    exportSettings?: ExportSettingsDto | undefined;
    hasContactPersons: boolean;
    hasNews: boolean;
    catalogViewShowPrice: DisplaySetting;
    catalogViewShowsProductNumber: boolean;
    catalogViewShowsGtin: boolean;
}

export enum CatalogStateEnum {
    New = 0,
    Preview = 100,
    Published = 200,
    PendingPublish = 300,
}

export enum CatalogLanguage {
    German = 0,
    English = 1,
    Italian = 2,
    French = 3,
    Spanish = 4,
    Dutch = 5,
    Danish = 6,
    Swedish = 7,
    Lithuanian = 8,
    Norwegian = 9,
    Estonian = 10,
    Latvian = 11,
    Polish = 12,
    Turkish = 13,
}

export interface FeatureToggleValuesDto {
    simpleFeatureToggles?: { [key in keyof typeof FeatureToggleName]?: boolean; } | undefined;
    numericFeatureToggles?: { [key in keyof typeof FeatureToggleName]?: number; } | undefined;
}

export enum FeatureToggleName {
    FeatureTogglesUseLicenseServer = 0,
    NewHelpdeskUrls = 1,
    CatalogViewAutoDeskForgeForIfc = 2,
    CatalogAdminIntegration = 3,
    CatalogAdminAdvertising = 4,
    CatalogAdminAnalyticsContacts = 5,
    CatalogAdminAnalyticsViewsInternalAdvertising = 6,
    LicenseCatalogCount = 7,
    LicenseKeywordCount = 8,
    LicenseCatalogItemsPerCatalog = 9,
    LicensePublishCatalog = 10,
    LicenseAnalyticsBasic = 11,
    LicenseAnalyticsAdvanced = 12,
    LicenseAnalyticsExperts = 13,
    LicenseAnalyticsIntegrationStatusCount = 14,
    LicenseAdditionalCategories = 15,
    LicenseCatalogManager = 16,
    WatchList = 17,
    CatalogNews = 18,
    IntegrationApi10SilentExport = 19,
    IntegrationV2IntegrationKeysMax = 20,
    LogoAds = 21,
}

export interface ExportSettingsDto {
    maxEverybodyPositions: number;
    maxRegisteredUsersPositions: number;
    minPositionsForWarning: number;
    exportLimit: ExportLimit;
}

export enum ExportLimit {
    Limited = 0,
    Unlimited = 1,
}

export enum DisplaySetting {
    Visible = 0,
    VisibleForRegisteredUsers = 1,
    Hidden = 2,
}

export interface CatalogViewRelatedCatalogsDto {
    id: number;
    key?: string | undefined;
    title?: string | undefined;
    categoryTitleResourceKeys?: string[] | undefined;
}

export interface CatalogViewNewsShortDto {
    id: number;
    imageUrl?: string | undefined;
    title?: string | undefined;
}

export interface CatalogViewNewsListDto {
    catalogViewNews?: CatalogViewNewsDto[] | undefined;
    webSite?: string | undefined;
}

export interface CatalogViewNewsDto {
    id: number;
    imageUrl?: string | undefined;
    teaser?: string | undefined;
    title?: string | undefined;
    text?: string | undefined;
    startDate?: Date | undefined;
    endDate: Date;
    categoryType: CatalogNewsCategoryType;
    keywords?: string[] | undefined;
    catalogItemGuid?: string | undefined;
    additionalInformationsUrl?: string | undefined;
    videoUrl?: string | undefined;
    type: NewsType;
}

export enum CatalogNewsCategoryType {
    News = 0,
    NewProduct = 1,
    DateAndEvents = 2,
    Sustainability = 3,
}

export enum NewsType {
    TextAndImage = 0,
    Video = 1,
}

export interface CatalogViewForeignLanguageCatalogsDto {
    id: number;
    key?: string | undefined;
    title?: string | undefined;
    languageAssetName?: string | undefined;
    categoryTitleResourceKeys?: string[] | undefined;
}

export interface CatalogViewTagDto {
    id: number;
    titleResourceKey?: string | undefined;
}

export interface CatalogItemDetailsDto {
    catalogId: number;
    catalogItemId: number;
    catalogKey?: string | undefined;
    type: CatalogItemType;
    tags?: TagType[] | undefined;
    viewGroups?: ViewGroupDto[] | undefined;
}

export enum CatalogItemType {
    Position = 0,
    TextPosition = 400,
    Document = 1200,
    Root = 2000,
    Folder = 3000,
    Unknown = -1,
}

export enum TagType {
    Unknown = 0,
    Image = 1,
    Video = 2,
    Document = 3,
    CadBim = 4,
    DataSheet = 11,
    Instruction = 12,
    Certificate = 13,
    PdfDrawing = 14,
    Sustainability = 15,
    CadFormat = 21,
    Ifc = 22,
    Price = 31,
    ProductNumber = 41,
    Din276 = 51,
    WorkCategory = 52,
    BimObject = 61,
    Cadenas = 62,
    CadClick = 63,
    Dgnb = 64,
}

export interface ViewGroupDto {
    viewGroup: ViewGroup;
    hasThumbnails: boolean;
    viewGroupItems?: ViewGroupItemDto[] | undefined;
}

export enum ViewGroup {
    Unknown = 0,
    Protocol = 50,
    CatalogInfo = 80,
    CatalogContact = 81,
    CatalogRelations = 82,
    CatalogContactPersons = 83,
    Overview = 100,
    OverviewFolder = 150,
    WatchlistFolder = 170,
    WatchlistUserdefinedFolder = 180,
    ImageAndVideo = 200,
    Images = 210,
    Videos = 220,
    Documents = 300,
    CadAndBim = 400,
    LinkAndComment = 500,
    Links = 510,
    Comments = 520,
    Sustainability = 900,
    Error = 1000,
}

export interface ViewGroupItemDto {
    attachmentType: AttachmentTypeEnum;
    viewer: Viewer;
    viewGroup: ViewGroup;
    id?: number | undefined;
    title?: string | undefined;
    displayUrl?: string | undefined;
    thumbnailUrl?: string | undefined;
    defaultImageUrl?: string | undefined;
    catalogItemId: number;
    text?: string | undefined;
    comment?: string | undefined;
    extension?: string | undefined;
    additionalInfos?: AdditionalInfoDto[] | undefined;
    links?: LinkDto[] | undefined;
    hasMetadata: boolean;
    metadataList?: MetadataDto[] | undefined;
    isPreview: boolean;
    isDownloadLoginRequired: boolean;
    sustainability?: DgnbDto | undefined;
    cadClick?: CadClickDto | undefined;
    bimObject?: BimObjectDto | undefined;
    catalogViewTreeItemType?: CatalogViewTreeItemType | undefined;
}

export enum AttachmentTypeEnum {
    Unknown = 0,
    Link = 10,
    Images = 200,
    Videos = 300,
    Documents = 400,
    Bim = 600,
    Error = -1,
}

export enum Viewer {
    Unknown = 0,
    CatalogInfoViewer = 110,
    CatalogContactViewer = 111,
    CatalogRelationsViewer = 112,
    CatalogContactPersonViewer = 113,
    ProtocolViewer = 200,
    WatchlistRoot = 300,
    WatchlistUserdefinedRoot = 320,
    WatchlistUserdefinedFolder = 321,
    FolderContentViewer = 500,
    FileViewer = 800,
    LinkViewer = 801,
    ImageViewer = 802,
    TextViewer = 803,
    PdfViewer = 805,
    IfcViewer = 806,
    HtmlViewer = 808,
    FileVideoViewer = 809,
    YoutubeVideoViewer = 810,
    VimeoVideoViewer = 811,
    AutodeskViewer = 850,
    BimObjectViewer = 851,
    CadenasViewer = 852,
    CadClickViewer = 853,
    SustainabilityViewer = 900,
}

export interface AdditionalInfoDto {
    title?: string | undefined;
    text?: string | undefined;
    showTitleAsString: boolean;
    isPrice: boolean;
}

export interface LinkDto {
    linkUrl?: string | undefined;
    id: number;
    title?: string | undefined;
}

export interface MetadataDto {
    key: Metadata;
    value?: string | undefined;
    tags?: KeyValuePairOfIntegerAndString[] | undefined;
}

export enum Metadata {
    None = 0,
    AttachmentName = 1,
    Extension = 2,
    FileName = 4,
    FileSizeFormat = 5,
    Tags = 6,
    FileSize = 7,
    Duration = 8,
    Pages = 9,
    Description = 10,
    UploadDate = 11,
}

export interface KeyValuePairOfIntegerAndString {
    key: number;
    value?: string | undefined;
}

export interface DgnbDto {
    product?: string | undefined;
    manufacturer?: string | undefined;
    dgnbGlobalWarmingPotentialItems?: DgnbGlobalWarmingPotentialItem[] | undefined;
    dgnbQualityLevelItems?: DgnbQualityLevelItem[] | undefined;
    dgnbDocumentItems?: DgnbDocumentItem[] | undefined;
    dgnbCertificateItems?: DgnbCertificateItem[] | undefined;
}

export interface DgnbGlobalWarmingPotentialItem {
    question?: string | undefined;
    answer?: string | undefined;
    unit?: string | undefined;
}

export interface DgnbQualityLevelItem {
    name?: string | undefined;
}

export interface DgnbDocumentItem {
    filename?: string | undefined;
    shortName?: string | undefined;
    documentUrl?: string | undefined;
    attachmentId: number;
}

export interface DgnbCertificateItem {
    name?: string | undefined;
    imageUrl?: string | undefined;
}

export interface CadClickDto {
    path?: string | undefined;
}

export interface BimObjectDto {
    gtin?: string | undefined;
}

export enum CatalogViewTreeItemType {
    Unknown = 0,
    Folder = 1,
    FolderWithAttachments = 2,
    TextOrDocument = 3,
    TextOrDocumentWithAttachments = 4,
    Position = 5,
    PositionWithAttachments = 6,
}

export interface CatalogViewGroupDto {
    id: number;
    manufacturerName?: string | undefined;
    catalogDescription?: string | undefined;
    streetAndNumber?: string | undefined;
    countryZipAndCity?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    email1?: string | undefined;
    email2?: string | undefined;
    webSite1?: string | undefined;
    webSite2?: string | undefined;
    countTexts: number;
    countImagesAndVideos: number;
    countDocuments: number;
    countCadAndBim: number;
    countLinks: number;
    socialMedia?: SocialMediaDto[] | undefined;
    lastUpdate: Date;
    categoriesResourceKeys?: CategoryResource[] | undefined;
    featureToggles?: FeatureToggleValuesDto | undefined;
}

export interface SocialMediaDto {
    socialMediaType: SocialMediaType;
    domain?: string | undefined;
    allowedDomainNames?: string[] | undefined;
}

export enum SocialMediaType {
    Unknown = 0,
    Xing = 1,
    Facebook = 2,
    Twitter = 3,
    Instagram = 4,
    LinkedIn = 5,
    YouTube = 6,
    Pinterest = 7,
}

export interface CategoryResource {
    categoryGroupResourceKey?: string | undefined;
    categoryResourceKey?: string | undefined;
}

export interface CatalogItemMetaDto {
    title?: string | undefined;
    description?: string | undefined;
    guid: string;
}

export interface CadenasDto {
    mIdentPath?: string | undefined;
    apiKey?: string | undefined;
    baseUrl?: string | undefined;
    userServerType?: string | undefined;
    path?: string | undefined;
    configuration?: string | undefined;
    catalog?: string | undefined;
    part?: string | undefined;
}

export interface CatalogItemFolderViewDto {
    id: number;
    title?: string | undefined;
    guid: string;
    description?: string | undefined;
    logo?: string | undefined;
}

export interface CatalogViewContactListDto {
    catalogViewContact?: CatalogViewContactDto[] | undefined;
}

export interface CatalogViewContactDto {
    id: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    title?: string | undefined;
    sector?: string | undefined;
    region?: string | undefined;
    email?: string | undefined;
    phoneOne?: string | undefined;
    phoneTwo?: string | undefined;
    contactPicture?: string | undefined;
}

export interface BimObjectEmbedData {
    iframeUrl?: string | undefined;
    files?: BimObjectEmbedDataFile[] | undefined;
}

export interface BimObjectEmbedDataFile {
    downloadUrl?: string | undefined;
    name?: string | undefined;
    fileTypeName?: string | undefined;
}

export interface ContactFormDto {
    requestTypes: number;
    professionGroupDtos?: ProfessionGroupDto[] | undefined;
    valuesDto?: ContactFormValuesDto | undefined;
    captcha?: CaptchaDto | undefined;
}

export interface ProfessionGroupDto {
    id: number;
    nameResourceKey?: string | undefined;
}

export interface ContactFormBaseDto {
    startTime: Date;
    userIdpOrClientId: string;
    catalogItemGuid?: string | undefined;
}

export interface ContactFormValuesDto extends ContactFormBaseDto {
    type: ContactFormType;
    requestTypes?: number | undefined;
    message?: string | undefined;
    eMail?: string | undefined;
    sendCopy: boolean;
    phone?: string | undefined;
    salutation?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    company?: string | undefined;
    searchTerm?: string | undefined;
    captchaCode?: string | undefined;
    captchaKey?: string | undefined;
    professionGroup?: number | undefined;
    contactPersonId?: number | undefined;
    editInfos?: { [key: string]: EditInfoDto; } | undefined;
}

export enum ContactFormType {
    Unknown = 0,
    CatalogContact = 1,
    CatalogItemContact = 2,
    GlobalSearchFeedback = 3,
    CatalogSearchFeedback = 4,
    NewsContact = 5,
    PersonContact = 6,
}

export interface EditInfoDto {
    maxLength: number;
    required: boolean;
    readonly: boolean;
    regex?: string | undefined;
}

export interface CaptchaDto {
    captchaImage: string;
    captchaKey: string;
}

export enum ContactFormSendResult {
    Sent = 0,
    CaptchaValidationFailed = 1,
    CaptchaValidationTimeout = 2,
}

export interface SimpleFeedbackDto {
    feedbackKey: string;
    contextUrl?: string | undefined;
    rating: number;
    message?: string | undefined;
}

export interface HomeLogoBarCatalogDto {
    key?: string | undefined;
    title?: string | undefined;
}

export interface LogoWallDto {
    id: number;
    key?: string | undefined;
    title?: string | undefined;
}

export enum LogoWallType {
    None = 0,
    NewEntryCatalogs = 1,
    RecentlyUpdatedCatalogs = 2,
    AllCatalogs = 3,
}

export interface HomeStatisticsDto {
    manufacturerCount: number;
    germanCatalogCount: number;
    internationalCatalogCount: number;
    categoryCount: number;
    totalTenderTexts: number;
    totalPlusInformation: number;
}

export interface InhouseNewsDto {
    id: number;
    type: NewsType;
    title?: string | undefined;
    teaser?: string | undefined;
    text?: string | undefined;
    imageUrl?: string | undefined;
    keywords?: string[] | undefined;
    additionalInformationsUrl?: string | undefined;
    videoUrl?: string | undefined;
    startDate?: Date | undefined;
    endDate: Date;
    originalImageUrl?: string | undefined;
    brand: InhouseNewsBrandType;
    categoryType: InhouseNewsCategoryType;
    isPublicView: boolean;
    isAdminView: boolean;
}

export enum InhouseNewsBrandType {
    Ade = 0,
    Orca = 1,
}

export enum InhouseNewsCategoryType {
    News = 0,
    DateAndEvents = 1,
    Sustainability = 2,
    NewFeatures = 3,
    Videos = 4,
    Whitepaper = 5,
    NewProduct = 6,
}

export interface CatalogsLanguagesGroupDto {
    catalogLanguage: CatalogLanguage;
    catalogs?: CatalogsLanguagesCatalogDto[] | undefined;
}

export interface CatalogsLanguagesCatalogDto extends CatalogViewListItemBase {
    isNewDate?: Date | undefined;
    categoryKeys?: string[] | undefined;
}

export interface SearchFeedbackFormDto {
    valuesDto?: SearchFeedbackFormValuesDto | undefined;
    captcha?: CaptchaDto | undefined;
}

export interface SearchFeedbackFormBaseDto {
    startTime: Date;
    userIdpOrClientId: string;
    catalogItemId?: string | undefined;
}

export interface SearchFeedbackFormValuesDto extends SearchFeedbackFormBaseDto {
    eMail?: string | undefined;
    subject?: string | undefined;
    message?: string | undefined;
    captchaCode?: string | undefined;
    captchaKey?: string | undefined;
    sendCopy: boolean;
    language?: NotificationLanguage | undefined;
    editInfos?: { [key: string]: EditInfoDto; } | undefined;
}

export enum NotificationLanguage {
    German = 0,
    English = 1,
}

export enum SearchFeedbackFormSendResult {
    Sent = 0,
    CaptchaValidationFailed = 1,
    CaptchaValidationTimeout = 2,
}

export interface WatchListInformationDto {
    maxWatchListItems: number;
    watchListVersion?: string | undefined;
    warningFolderCount: number;
    exportSettings?: ExportSettingsDto | undefined;
}

export interface WatchListFlatDto {
    tooManyItems: boolean;
    catalogItemGuids?: string[] | undefined;
    currentWatchListItemsCount: number;
}

export interface WatchListCheckDto {
    existsInUserDefinedList: boolean;
    catalogItemTitle?: string | undefined;
    catalogItemCount: number;
}

export interface WatchListDto {
    watchListId: number;
    catalogs?: WatchListItemDto[] | undefined;
    unavailableCatalogItems?: UnavailableWatchListItemDto[] | undefined;
}

export interface WatchListItemDto {
    title?: string | undefined;
    catalogItemGuid: string;
    id: number;
    catalogKey?: string | undefined;
    type: CatalogViewTreeItemType;
    children?: WatchListItemDto[] | undefined;
}

export interface UnavailableWatchListItemDto {
    catalogItemTitle?: string | undefined;
    catalogId: number;
}

export enum WatchListStructure {
    Catalog = 0,
    CatalogAndStructure = 1,
    UserDefined = 2,
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}